import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { QcComponentsModule } from '@qivos/qivoscloud-ion-components';
import { CsiConfig } from '@qivos/qivoscloud-ion-components/lib/models/csi.model';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [IonicModule, QcComponentsModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent {
  constructor() {}

  startingPageConfiguration: CsiConfig = {
    logo: '../assets/LOGO.jpg',
    welcomeMsg: 'Η γνώμη σου είναι σημαντική!',
    title: 'Αγαπητό Holland & Barrett μέλος',
    mainText:
      'Σε ευχαριστούμε για την πρόσφατη αγορά σου! Θα θέλαμε να μας βοηθήσεις να γίνουμε καλύτεροι συμπληρώνοντας ένα μικρό ερωτηματολόγιο 3ων ερωτήσεων για την πρόσφατη εμπειρία σου!',
    questionnaireUrlText: 'ΑΣ ΞΕΚΙΝΗΣΟΥΜΕ',
    footerText:
      'Το ερωτηματολόγιο θα παραμείνει διαθέσιμο για 14 ημέρες από την ημερομηνία αποστολής του μηνύματος.',
    questionsData: [
      'Πώς θα αξιολογούσες την ποιότητα των προϊόντων που αγόρασες σε σχέση με την τιμή που πλήρωσες;',
      'Πόσο ικανοποιημένος/η είσαι από την εμπειρία της εξυπηρέτησης, είτε από το προσωπικό στο φυσικό κατάστημα είτε από τη λειτουργικότητα του eShop κατά την αγορά σου;',
      'Πώς θα αξιολογούσες τη συνολική σου εμπειρία, λαμβάνοντας υπόψη την ατμόσφαιρα στο φυσικό κατάστημα (μουσική, κλιματισμός, φωτισμός, καθαριότητα) ή την ευχρηστία και την οργάνωση του eShop;',
    ],
    numericQuestionDescription:
      'Με κλίμακα 1-10, θα πρότεινες τη Holland & Barrett σε κάποιον φίλο ή συνεργάτη σου;',

    successMsg: 'Σε ευχαριστούμε!',
    successText:
      'Οι απαντήσεις σου θα μας βοηθήσουν να προσφέρουμε μια καλύτερη εμπειρία για όλους  τους πελάτες μας.',
    expiredMsg: 'Λυπούμαστε',
    expiredText: 'Αυτή η σελίδα έχει λήξει',
    submitButtonText: 'ΑΠΟΣΤΟΛΗ',
    buttonColorText: '#00594c',
    siteUrl: '',
    account: 'hollandandbarrett',
    language: 'el',
    formId: 'hollandandbarrett',
    iconsValue: ['ΠΟΛΥ ΚΑΚΗ', 'ΚΑΚΗ', 'ΜΕΤΡΙΑ', 'ΚΑΛΗ', 'ΕΞΑΙΡΕΤΙΚΗ'],
    buttonBackgroundColor: '',
    textAreaValidation: '',
    textAreaQuestion: '',
  };
}
